import { useContext, useState } from "react";
import { ThemeContext } from "../../../context/theme-context";
import { Container } from "react-bootstrap";
import { IFinancialTransaction } from "../../../redux/features/financialTransaction/interface";
import { ListaFinanceiro } from "../../../Components/Financeiro/TrancacaoFinanceira/ListaFinanceiro";
import { FormTransacao } from "../../../Components/Financeiro/TrancacaoFinanceira/FormTransacao";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";

export interface IListFinancial {
  onEditItem: (item: IFinancialTransaction) => void;
  onAddNewCli: (e: boolean) => void;
  financialData?: any;
  entryType: number;
  title: string;
  dispatch: any;
}

export interface IFormFinancial {
  title: string;
  OnAddNewFinancial: (e: boolean) => void;
  financialData?: any;
  entryType: number;
  editando: boolean;
  dispatch: any;
}

export default function CadFinanceiroReceita() {
  const dispatch = useDispatch<AppDispatch>();

  const { collapsed } = useContext(ThemeContext);
  const [cad, setCad] = useState<boolean>(false);
  const [toEditFinancial, setToEditFinancial] =
    useState<IFinancialTransaction>();
  const [editando, setEditando] = useState<boolean>(false);

  const handleNew = (e: boolean) => {
    setEditando(false);
    setToEditFinancial(undefined);
    setCad(e);
  };

  const handleEdit = (props: IFinancialTransaction) => {
    setToEditFinancial(props);
    setCad(true);
    setEditando(true);
  };

  const handleClearCancelBtn = (e: any) => {
    setToEditFinancial(undefined);
  };

  return (
    <>
      {!cad ? (
        <Container
          className={collapsed ? "contenteLayoutCollapsed" : "contenteLayout"}
        >
          <ListaFinanceiro
            title="Receita"
            dispatch={dispatch}
            entryType={1}
            onEditItem={(item: IFinancialTransaction) => handleEdit(item)}
            financialData={toEditFinancial}
            onAddNewCli={(e: boolean) => {
              handleNew(e);
            }}
          />
        </Container>
      ) : (
        <Container
          className={collapsed ? "contenteLayoutCollapsed" : "contenteLayout"}
        >
          <FormTransacao
            Title="Adicionar Movimentação Financeira Receita"
            EntryType={1}
            Label="Recebimento"
            Placeholder="Forma Recebimento"
            Path="financial-transaction"
            dispatch={dispatch}
            onAddNewTransaction={(efinancial: boolean) => {
              handleNew(efinancial);
            }}
            OnClear={(efinancial: boolean) => {
              handleClearCancelBtn(efinancial);
            }}
            transacao={toEditFinancial}
            editando={editando}
          />
        </Container>
      )}
    </>
  );
}
